import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2, X } from 'lucide-react';
const NAMES = ['Martín', 'Santiago', 'Lucía', 'Valentina', 'Matías', 'Florencia', 'Nicolás', 'Camila', 'Federico', 'Carolina', 'Sebastián', 'María', 'Agustín', 'Paula', 'Diego'];
const LAST_NAMES = ['G.', 'R.', 'L.', 'M.', 'F.', 'P.', 'S.', 'T.', 'V.', 'C.'];
const CITIES = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'Tucumán', 'La Plata', 'Mar del Plata', 'Salta', 'Santa Fe', 'Neuquén', 'Bahía Blanca', 'Resistencia', 'Posadas'];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    const showPopup = () => {
      const randomName = `${NAMES[Math.floor(Math.random() * NAMES.length)]} ${LAST_NAMES[Math.floor(Math.random() * LAST_NAMES.length)]}`;
      const randomCity = CITIES[Math.floor(Math.random() * CITIES.length)];
      setCurrentPurchase({
        name: randomName,
        city: randomCity
      });
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 4000);
    };
    // Initial delay
    const initialTimeout = setTimeout(showPopup, 5000);
    // Random interval between 12 and 18 seconds
    const interval = setInterval(() => {
      showPopup();
    }, Math.floor(Math.random() * (18000 - 12000 + 1) + 12000));
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-228">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.95
    }} className="fixed bottom-6 left-6 z-50 max-w-sm bg-[#111827] border border-gray-800 rounded-xl shadow-2xl p-4 pr-10 flex items-start gap-3" data-id="element-229">
          <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-gray-500 hover:text-gray-300" data-id="element-230">
            <X className="w-4 h-4" data-id="element-231" />
          </button>

          <div className="mt-1 flex-shrink-0" data-id="element-232">
            <CheckCircle2 className="w-6 h-6 text-green-500" data-id="element-233" />
          </div>

          <div data-id="element-234">
            <p className="text-sm font-medium text-gray-200" data-id="element-235">
              <span className="font-bold text-white" data-id="element-236">
                {currentPurchase.name}
              </span>{' '}
              de {currentPurchase.city}
            </p>
            <p className="text-xs text-yellow-500 mt-1" data-id="element-237">
              acaba de adquirir el Mega Kit Neuro-Pro
            </p>
            <p className="text-[10px] text-gray-500 mt-1" data-id="element-238">
              Hace unos instantes
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}